module.exports = __webpack_public_path__ + "img/pre_point_end.f6b51b67.svg";